const yup = require("yup");

const dispute = yup.object().shape({
  reason: yup.string().required("Reason for dispute is required"),
  productType: yup.string().required("Product type is required"),
  description: yup.string().trim().required("Description is required"),
});

export default dispute;
